var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex_center"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/bottom/bottom.png")}})]),_c('div',{staticClass:"hrr"})])
}]

export { render, staticRenderFns }